import React, { useEffect } from 'react';
import { FontWeight, LabelProps, Switch } from '@easylife365/react';
import { useTranslation } from 'react-i18next';
import { useCanShowAllApps } from '../../../lib/hooks';
import { useFilterContext } from '../../../lib/state';

const AllResourcesSwitch: React.FC = () => {
  const { t } = useTranslation('common');
  const canShowAllApps = useCanShowAllApps();
  const { showAllApps, toggleAllApps } = useFilterContext();

  // An admin can narrow access mid-session; a disabled switch must not stay on where the user cannot turn it off
  useEffect(() => {
    if (showAllApps && !canShowAllApps) toggleAllApps();
  }, [showAllApps, canShowAllApps, toggleAllApps]);

  const labelProps: LabelProps = {
    label: t('switches.showAllApps'),
    fontWeight: FontWeight.SemiBold,
  };

  return <Switch disabled={!canShowAllApps} label={labelProps} onChange={toggleAllApps} checked={showAllApps} />;
};

export default AllResourcesSwitch;
